$(document).on("click", ".info, .info-block-box, .info-text-link", function () {
  const $elem = $(this);
  const title = $elem.attr("title");
  const html = $elem.data("info");

  $modal = $(".info-modal");
  $modal.find(".info-modal-title").html(title);
  $modal.find(".info-modal-content").html(html);
  $modal.modal().show();
});
